import { useEffect, useState, useRef } from 'react';
import StyledWrapper from '../../../IndividualProgram/style';
import { Tooltip } from '@mui/material';

const SimpleTooltip = ({ cellValues }) => {
	const [isOverflowing, setIsOverflowing] = useState(false);
	const cardRowRef = useRef(null);
	useEffect(() => {
		if (cardRowRef.current) {
			setIsOverflowing(cardRowRef.current.scrollWidth > cardRowRef.current.clientWidth);
		}
	}, [cellValues]);

	return (
		<Tooltip arrow placement="top" title={isOverflowing ? `${cellValues?.formattedValue}` : ''}>
			<StyledWrapper.CardRowInfo
				ref={cardRowRef}
				data-testid={`${cellValues?.field}-${cellValues?.id}`}
			>
				{cellValues?.formattedValue}
			</StyledWrapper.CardRowInfo>
		</Tooltip>
	);
};

export default SimpleTooltip;
